import { Link, type LinkProps } from "react-router";

import { cn } from "@/lib/utils";

type Props = LinkProps & {
	isWithIcon?: boolean;
	isUnderlined?: boolean;
};

export const UnstyledLink = (props: Props) => {
	const { isWithIcon, isUnderlined, className, ...rest } = props;

	const linkClasses = cn(
		"text-primary font-medium no-underline focus:outline-none",
		isUnderlined && "underline",
		className,
	);

	if (isWithIcon) {
		return (
			<div className="[&_a]:flex [&_a]:items-center [&_svg]:w-4 [&_svg]:h-auto [&_svg]:mr-2">
				<Link tabIndex={-1} className={linkClasses} {...rest}>
					{props.children}
				</Link>
			</div>
		);
	}

	return <Link tabIndex={-1} className={linkClasses} {...rest} />;
};
